
const DeviceItem = ({
  icon,
  label,
  value,
  statusIcon,
  copy = false,
  onCopy,
  className,
  deviceState = false,
  edit = false,
  onChange
}) => (
  <>
    <div className={`${className} container-management-details-icon`}><i className={icon}></i></div>
    <div className={`${className} container-management-details-label`}>{label}</div>

    {statusIcon && (
      <div className={`${className}-status container-management-details-icon`}><i className={statusIcon}></i></div>
    )}

    <div className={`${className} container-management-details-value`}>{value}</div>

    {copy && (
      <div className={`${className}-copy container-management-details-icon`} onClick={() => onCopy && onCopy(value)}>
        <i className='fas fa-copy'></i>
      </div>
    )}

    {edit && (
      <div className={`${className}-slider`}>
        <label className='switch'>
          <input
            type='checkbox'
            checked={deviceState}
            value={deviceState}
            onChange={(e) => onChange && onChange(e)}
          />
          <span className='slider round'></span>
        </label>
      </div>
    )}
  </>
);

const Devices = ({ devices }) => (
  <>
    <div className="container-management-details-devices container-management-details-title">Devices</div>
    {devices.map((device, index) => (
      <DeviceItem
        key={index}
        icon={device.icon}
        label={device.label}
        value={device.value}
        statusIcon={device.statusIcon}
        copy={device.copy}
        onCopy={device.onCopy}
        className={device.className}
        edit={device.edit}
        deviceState={device.deviceState}
        onChange={device.onChange}
      />
    ))}
  </>
);

export default Devices;